var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21967 1.78336L4.71967 0.227806C5.01256 -0.0759353 5.48744 -0.0759353 5.78033 0.227806C6.05069 0.508182 6.07149 0.949362 5.84272 1.25448L5.78033 1.32775L5.54187 1.57346C5.6937 1.56155 5.84649 1.55556 6 1.55556C9.31371 1.55556 12 4.34134 12 7.77778C12 11.2142 9.31371 14 6 14C2.68629 14 0 11.2142 0 7.77778C0 7.34822 0.335786 7 0.75 7C1.16421 7 1.5 7.34822 1.5 7.77778C1.5 10.3551 3.51472 12.4444 6 12.4444C8.48528 12.4444 10.5 10.3551 10.5 7.77778C10.5 5.20045 8.48528 3.11111 6 3.11111C5.8597 3.11111 5.72034 3.11775 5.58221 3.13091L5.78033 3.33892C6.07322 3.64266 6.07322 4.13512 5.78033 4.43886C5.50997 4.71924 5.08454 4.7408 4.79033 4.50356L4.71967 4.43886L3.21967 2.88331C2.94931 2.60293 2.92851 2.16175 3.15728 1.85663L3.21967 1.78336L4.71967 0.227806L3.21967 1.78336Z",
    fill: "#F5F6F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reloadIcon.9962714b.svg";
export { ForwardRef as ReactComponent };